module.exports = __webpack_public_path__ + "img/camera.8d876f10.svg";